import TmdbLogo from "../../images/tmdb-logo.svg";
import './Footer.css'
import './FooterLinks.css'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div><strong>Find A Film</strong><span>Less searching. More watching.</span></div>
      <nav><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><Link to="/support">Support</Link></nav>
      <a href="https://www.themoviedb.org/?language=en-GB" target="_blank" rel="noreferrer">
        <span>Powered by</span><img className="footer__logo" src={TmdbLogo} alt="The Movie Database" />
      </a>
    </footer>
  )
}

export default Footer;
